/**
 * Perfil profesional MSP (registro local) — el backend actual de registro no persiste matrícula;
 * se guarda por correo para pre-rellenar la ficha odontológica y datos del profesional.
 */
const STORAGE_KEY = 'ecommers_professional_profile_v1';

export function normalizeProfessionalEmail(email) {
  return String(email || '').trim().toLowerCase();
}

export function loadProfessionalProfile(email) {
  const key = normalizeProfessionalEmail(email);
  if (!key) return null;
  try {
    const all = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    const row = all[key];
    if (!row || typeof row !== 'object') return null;
    return {
      nombreCompleto: String(row.nombreCompleto || ''),
      registroMSP: String(row.registroMSP || ''),
      cedulaProfesional: String(row.cedulaProfesional || ''),
      especialidad: String(row.especialidad || ''),
      updatedAt: row.updatedAt || '',
    };
  } catch {
    return null;
  }
}

export function saveProfessionalProfile(email, payload) {
  const key = normalizeProfessionalEmail(email);
  if (!key) return;
  try {
    const all = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    all[key] = {
      nombreCompleto: String(payload?.nombreCompleto || '').trim(),
      registroMSP: String(payload?.registroMSP || '').trim(),
      cedulaProfesional: String(payload?.cedulaProfesional || '').trim(),
      especialidad: String(payload?.especialidad || '').trim(),
      updatedAt: new Date().toISOString(),
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
  } catch {
    /* ignore quota */
  }
}
